import {withAuthCreds} from "./AuthCredentials";
import {onCallError} from "./Utils";

const API_URL = process.env.REACT_APP_API_URL;

/*
 *Updates the review state of a given check
 **/
export async function UpdateReviewState(tranID, itemID, reviewState, reviewerUsername, rejectReason = null) {
    try {
        return await withAuthCreds().patch(
            `${API_URL}/Review/UpdateReviewState?tranID=${tranID}&itemID=${itemID}&reviewState=${reviewState}&reviewerUsername=${reviewerUsername}&rejectReason=${rejectReason}`
        );
    } catch (error) {
        return onCallError(error);
    }
}

/*
 *Updates the check amount
 **/
export async function UpdateCheckAmount(tranID, itemID, amount) {
    try {
        return await withAuthCreds().patch(
            `${API_URL}/Review/UpdateItemAmount?tranID=${tranID}&itemID=${itemID}&amount=${amount}`
        );
    } catch (error) {
        return onCallError(error);
    }
}

/*
 *Updates the check MICR
 **/
export async function UpdateCheckMICR(tranID, itemID, micr) {
    try {
        return await withAuthCreds().patch(
            `${API_URL}/Review/UpdateItemMicr?tranID=${tranID}&itemID=${itemID}&micr=${micr}`
        );
    } catch (error) {
        return onCallError(error);
    }
}

/*
 *Locks or unlocks the user's account
 **/
export async function toggleUserLockStatus(email) {
    try {
        return await withAuthCreds().patch(
            `${API_URL}/Account/ToggleUserLockStatus?email=${email}`
        );
    } catch (error) {
        return onCallError(error);
    }
}

export async function updateCustomerConfigs(customerConfigs) {
    try {
        return await withAuthCreds().post(`${API_URL}/Config/UpdateCustomerConfigs`, customerConfigs, {
            headers: {'Content-Type': 'application/json'}
        });
    } catch (error) {
        return onCallError(error);
    }
}

/*
Adds a blacklisted account number by sending a POST request to the API with the account number.
 */
export async function addBlacklistDestAccount(account) {
    try {
        return await withAuthCreds().post(
            `${API_URL}/Config/AddBlacklistDestAccount?account=${account}`
        )
    } catch (error) {
        return onCallError(error);
    }
}

/*
Removes a blacklisted account number by sending a DELETE request to the API with the account number.
 */
export async function removeBlacklistDestAccount(account) {
    try {
        return await withAuthCreds().delete(
            `${API_URL}/Config/RemoveBlacklistDestAccount?account=${account}`
        )
    } catch (error) {
        return onCallError(error);
    }
}

/*
Adds a blacklisted routing number by sending a POST request to the API with the routing number.
 */
export async function addBlacklistedRouting(routing) {
    try {
        return await withAuthCreds().post(
            `${API_URL}/Config/AddBlacklistedRouting?routing=${routing}`
        )
    } catch (error) {
        return onCallError(error);
    }
}

/*
Adds a TrueChecks blacklisted routing number by sending a POST request to the API with the routing number.
 */
export async function addTrueChecksBlacklistedRouting(routing) {
    try {
        return await withAuthCreds().post(
            `${API_URL}/Config/AddTrueChecksBlacklistedRouting?routing=${routing}`
        )
    } catch (error) {
        return onCallError(error);
    }
}

/*
Removes a blacklisted routing number by sending a DELETE request to the API with the routing number.
 */
export async function removeBlacklistedRouting(routing) {
    try {
        return await withAuthCreds().delete(
            `${API_URL}/Config/RemoveBlacklistedRouting?routing=${routing}`
        )
    } catch (error) {
        return onCallError(error);
    }
}

/*
Removes a TrueChecks blacklisted routing number by sending a DELETE request to the API with the routing number.
 */
export async function removeTrueChecksBlacklistedRouting(routing) {
    try {
        return await withAuthCreds().delete(
            `${API_URL}/Config/RemoveTrueChecksBlacklistedRouting?routing=${routing}`
        )
    } catch (error) {
        return onCallError(error);
    }
}

/**
 * @description Updates the name of a branch by sending a PATCH request to the API.
 * @param {string} branchId - The guid string of the branch to be updated.
 * @param {string} newBranchName - The new name string for the branch.
 * @param {string} timeZone - The new time zone for the branch
 * @returns {Promise} - Data response from the API.
 * @throws {Error} - Console logs an error if the request fails.
 */
export async function updateBranchDetails(branchId, newBranchName, timeZone) {
    try {
        return await withAuthCreds().patch(
            `${API_URL}/Account/UpdateBranchDetails?branchId=${branchId}&newBranchName=${newBranchName}&timeZone=${timeZone}`
        );
    } catch (error) {
        return onCallError(error);
    }
}

/**
 * @description Deletes a Terminal ID GUID by sending a DELETE request to the API.
 * @param {string} terminalId - The guid string of the terminal to be deleted.
 * @returns {Promise} - Data response from the API.
 * @throws {Error} - Console logs an error if the request fails.
 */
// export async function deleteTerminalId(terminalId) {
//   try {
//     return await withAuthCreds().delete(
//         `${API_URL}/Account/DeleteTerminalId?terminalId=${terminalId}`
//     );
//   } catch (error) {
//     console.error(error);
//   }
// }